"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMoistureLoadACLMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.setMoistureLoadACLMutation = (0, graphql_tag_1.default) `
  mutation SetMoistureLoadACLMutation(
    $input: UpdateMoistureLoadFileAccessInputType!
  ) {
    setMoistureLoadACL(input: $input) {
      id
      errorMessage
    }
  }
`;
//# sourceMappingURL=set-moisture-load-acl.js.map